<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import Privacy from "./Privacy.svelte";
</script>

<ShellLayout><Privacy /></ShellLayout>
